import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import debounce from 'lodash/debounce';

import * as actions from '../../actions';
import { getLevelState, getSelectedTabKey } from '../../selectors';

import TemplateLoader from '../common/TemplateLoader';
import TabPanelItem from './TabPanelItem';


class TabPanel extends Component {
  // eslint-disable-next-line
  static defaultProps = {
    dragEnabled: true,
    responsive: true,
    sortProp: 'position',
    filterProp: 'deleted',
    itemWidth: 180,
    itemHeight: 40 // Sync this with item height of item
  };

  constructor(props) {
    super(props);
    this.handleOnMove = debounce(this.handleOnMove.bind(this), 40);
  }


  handleOnMove(from, to) {
    const { moveTab } = this.props;
    moveTab(from, to);
  }


  render() {
    const { items, selectedKey, responsive, itemWidth, itemHeight, dragEnabled, sortProp, filterProp, isFetching, render } = this.props; 

    if (isFetching) {
      return <TemplateLoader />
    }

    const displayProps = {
      selectedKey
    };

    const gridProps = {
      items,
      responsive,
      itemWidth,
      itemHeight,
      dragEnabled,
      sortProp,
      filterProp,
      onMove: this.handleOnMove
    };

    return (
      <div>
        {render(TabPanelItem, displayProps, gridProps)}
      </div>
    );
  }
}


function mapStateToProps(state) {
  const { isFetching, items } = getLevelState(state);
  return {
    items,
    isFetching,
    selectedKey: getSelectedTabKey(state)
  };
}


function mapDispatchToProps(dispatch) {
  const { moveTab } = actions;
  return bindActionCreators({
    moveTab
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(TabPanel);
